import React, { createRef } from 'react';
import queryString from 'query-string';
import { Card, Col, Row } from 'react-bootstrap';
import { Form, Button } from 'react-bootstrap';
import SelectDate from '../../component/SelectDate';

import PageBar from '../../component/PageBar';
import { GetList, DeleteArray, GetListDownload } from './http';
import { GetList as GetListBranch } from '../branch/http';
import { GetList as GetListDriver } from '../driver/http';
import moment from 'moment';

import ReactToPrint from 'react-to-print';
import PrintReportSafe from '../../print/report_safe';
import PrintReportWork from '../../print/report_work';
import download from 'downloadjs';

class List extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            search: {
                page: 1,
                size: 30,
                sort: 'name',
                name: '',
                createdAt: [undefined, undefined],
            },
            branch: [],
            driver: [],
            totalPages: 20,
            selectData: '',
        };
        this.state.search.createdAt[0] = moment().format('YYYY-MM-01 00:00:00');
        this.state.search.createdAt[1] = moment().format('YYYY-MM-DD 23:59:59');

        this.printBill = createRef();
        this.printBill2 = createRef();
        this.printBill2Btn = createRef();

        const params = sessionStorage.getItem('report_search');
        if (params) {
            // this.state.search = JSON.parse(params);
        }

        GetListBranch(this, { role: 'BRANCH', status: 'OPENED', sort: 'title' }, res => {
            const rows = res.rows.map(x => {
                return { idx: x.id, title: x.title };
            });
            rows.unshift({ idx: '', title: '지사별보기선택' });

            this.setState({
                branch: rows,
            });
        });
        this.reloadDriverList();

        this.reloadList(1);
    }

    reloadList = page => {
        const params = this.state.search;
        params.page = page;
        sessionStorage.setItem('report_search', JSON.stringify(params));

        this.setState({
            search: params,
        });

        GetList(this, params, this.resultList.bind(this));
    };

    reloadDriverList = () => {
        const { search } = this.state;
        if (search.branchId) {
            GetListDriver(this, { branchId: search.branchId, status: 'OPENED', sort: 'name' }, res => {
                const rows = res.rows.map(x => {
                    return { idx: x.id, title: x.name };
                });
                rows.unshift({ idx: '', title: '기사별보기선택' });

                this.setState({
                    driver: rows,
                });
            });
        } else {
            GetListDriver(this, { status: 'OPENED', sort: 'name' }, res => {
                const rows = res.rows.map(x => {
                    return { idx: x.id, title: x.name };
                });
                rows.unshift({ idx: '', title: '기사별보기선택' });

                this.setState({
                    driver: rows,
                });
            });
        }
    };

    /**
     * 리스트
     */
    resultList = response => {
        this.setState({
            items: response.rows,
            totalPages: Math.ceil(response.range.total / response.range.size),
        });
    };

    /**
     * 클릭
     * @param {*} item
     */
    clickRow = item => {
        window.location = '/a/report/info/' + item.id;
    };

    /**
     * 삭제
     * @param {*} e
     */
    clickDelete = e => {
        const data = this.state.items.filter(x => x.check && x.report).map(x => x.report.id);
        if (data.length === 0) {
            return;
        }

        if (window.confirm('삭제 하시겠습니까?')) {
            DeleteArray(this, data, res => {
                alert('삭제가 완료 되었습니다.');
                this.reloadList(this.state.search.page);
            });
        }
    };

    render() {
        const { items, search, branch, driver, selectData } = this.state;

        const itemsCheck = items.filter(x => x.check);

        return (
            <div>
                <Row>
                    <Col>
                        <div className="board_top_box green">
                            <div className="lb">
                                <Form.Control
                                    as="select"
                                    onChange={e => {
                                        search.branchId = e.target.value;
                                        search.driverId = '';

                                        this.setState({ search }, () => {
                                            this.reloadDriverList();
                                        });
                                    }}
                                    value={search.branchId}
                                >
                                    {branch.map(x => (
                                        <option value={x.idx}>{x.title}</option>
                                    ))}
                                </Form.Control>

                                <Form.Control
                                    as="select"
                                    onChange={e => {
                                        search.driverId = e.target.value;
                                        this.setState({ search });
                                    }}
                                    value={search.driverId}
                                >
                                    {driver.map(x => (
                                        <option value={x.idx}>{x.title}</option>
                                    ))}
                                </Form.Control>

                                <div className="gab-w-10"></div>

                                <SelectDate
                                    title=""
                                    from={search.createdAt[0]}
                                    to={search.createdAt[1]}
                                    onChange={(from, to) => {
                                        search.createdAt[0] = moment(from, 'YYYY.MM.DD').format('YYYY-MM-DD 00:00:00');
                                        search.createdAt[1] = moment(to, 'YYYY.MM.DD').format('YYYY-MM-DD 23:59:59');
                                        this.setState(search);
                                    }}
                                />

                                <div className="gab-w-10"></div>

                                <div className="search_box_2">
                                    <input
                                        placeholder="검색어를 입력하세요."
                                        type="text"
                                        class="form-control search01"
                                        onChange={e => {
                                            search.name = e.target.value;
                                            this.setState({ search });
                                        }}
                                        onKeyPress={e => {
                                            if (e.key === 'Enter') {
                                                this.reloadList(1);
                                            }
                                        }}
                                    />
                                    <button class="btn_01 deep" onClick={e => this.reloadList(1)}>
                                        검색
                                    </button>
                                </div>
                            </div>

                            <div className="rb"></div>
                        </div>

                        <Card style={{ display: 'none' }}>
                            <div ref={this.printBill}>
                                {itemsCheck.map(x => [<PrintReportWork data={x} />, <PrintReportSafe data={x} />])}
                                {itemsCheck.length === 0 && <div style={{ textAlign: 'center', padding: 40 }}>데이터를 선택해주세요.</div>}
                            </div>
                        </Card>

                        <Card style={{ display: 'none' }}>
                            {selectData && (
                                <div ref={this.printBill2}>
                                    <PrintReportWork data={selectData} />
                                    <PrintReportSafe data={selectData} />
                                </div>
                            )}
                        </Card>

                        <Card>
                            <Card.Header style={{ backgroundColor: '#66b1a6' }}>
                                <Card.Title as="h5">지사 리스트</Card.Title>
                                <div className="rb">
                                    <button
                                        type="button"
                                        className="btn_01 b_excel"
                                        onClick={e => {
                                            const params = this.state.search;

                                            GetListDownload(this, params, res => {
                                                download(atob(res), 'reports.xlsx', {
                                                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                                });
                                            });
                                        }}
                                    >
                                        엑셀다운로드
                                    </button>
                                    <ReactToPrint
                                        trigger={() => {
                                            return (
                                                <button type="button" className="btn_02">
                                                    교육일지출력
                                                </button>
                                            );
                                        }}
                                        content={() => this.printBill.current}
                                    />

                                    <ReactToPrint
                                        trigger={() => {
                                            return <span />;
                                        }}
                                        content={() => this.printBill2.current}
                                        ref={this.printBill2Btn}
                                    />

                                    <button type="button" className="btn_02 red" onClick={this.clickDelete}>
                                        목록삭제
                                    </button>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <div className="table_board_box">
                                    <table className="tbl_board list bg">
                                        <colgroup>
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>지역사무소</th>
                                                <th>이름</th>
                                                <th>연락처</th>
                                                <th>차량번호</th>
                                                <th>등록일</th>
                                                <th>아이디</th>
                                                <th>교육일지 확인</th>
                                                <th></th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {items.map(x => (
                                                <tr>
                                                    <td>{x.id}</td>
                                                    <td>{x.branch ? x.branch.title : ''}</td>
                                                    <td>{x.name}</td>
                                                    <td>{x.phone}</td>
                                                    <td>{x.carNumber}</td>
                                                    <td>{x.report ? moment(x.report.createdAt).format('YYYY-MM-DD') : ''}</td>
                                                    <td>{x.appId}</td>
                                                    <td>{x.report ? '확인' : ''}</td>
                                                    <td>
                                                        {x.report && (
                                                            <input
                                                                type="checkbox"
                                                                checked={x.check}
                                                                onChange={e => {
                                                                    x.check = !x.check;
                                                                    this.setState({});
                                                                }}
                                                            />
                                                        )}
                                                    </td>
                                                    <td>
                                                        {x.report && (
                                                            <button
                                                                type="button"
                                                                className="btn_02"
                                                                onClick={e => {
                                                                    this.setState({ selectData: x }, e => {
                                                                        this.printBill2Btn.current.handleClick();
                                                                    });
                                                                }}
                                                            >
                                                                교육일지 보기
                                                            </button>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="gab40"></div>

                                <div className="textRight">
                                    <PageBar nowPage={Number(this.state.search.page)} totalPage={this.state.totalPages} reload={this.reloadList} />
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default List;
